import { css } from "lit";

export const routerCss = css`
  :host {
    display: block;
    overflow: hidden;
  }

  .page {
    opacity: 1;
    transform: translateY(0);
    overflow: hidden;
    height: 100%;
  }
`;
